<div *ngIf="dataLoaded">
  <div class="title-description">
    <app-title-info subTitle="Project Configuration"></app-title-info>
    <app-tag [title]="'Configuration In Progress'"></app-tag>
  </div>
  <app-title-info [title]="project.projectTitle" [subTitle]="projectDescription" [styles]="stylesObj"></app-title-info>
  <app-divider-line></app-divider-line>

  <div [ngSwitch]="steps[currentStep].step">
    <div *ngSwitchCase="1">
      <app-solution-offerings-step [projectDetails]="project" [settingsMode]="false"></app-solution-offerings-step>
    </div>
    <div *ngSwitchCase="2">
      <app-scenario-step></app-scenario-step>
    </div>
    <div *ngSwitchCase="3">
      <app-modules-step></app-modules-step>
    </div>
    <div *ngSwitchCase="4">
      <app-users-step></app-users-step>
    </div>
    <div *ngSwitchCase="5">
      <app-questionnaire-step></app-questionnaire-step>
    </div>
  </div>

  <div class="d-flex justify-content-end gap">
    <button *ngIf="hasPreviousStep()" (click)="goToStep(currentStep - 1)" mat-stroked-button>
      <img src="assets/images/icons/back-arrow.svg" alt="Back Arrow" />
      {{ steps[currentStep - 1].title }}
    </button>
    <button mat-stroked-button class="exit" (click)="confirmExit()">Exit Configuration</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="!pcDataService.projectConfigurationFormGroup.controls[steps[currentStep].formGroupControlName].valid"
      (click)="goToStep(currentStep + 1)"
    >
      {{ nextStepTitle() }}
      <img src="assets/images/icons/next-arrow.svg" alt="Next Arrow" />
    </button>
  </div>
</div>
